<template>
    <v-container fluid class="pa-0">
        <v-card>
            <v-card-title primary-title>
                <v-row>
                    <v-col>Experiment Methods</v-col>
                    <v-spacer />
                    <v-col class="text-right" v-if="userCanManageExperimentMethods">
                        <v-btn color="primary" @click="showExperimentMethodForm"
                        >Create Experiment Method</v-btn
                        >
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <experiment-methods-list
                    :experiment-methods="experimentMethods"
                    @edit-experiment-method="handleEditExperimentMethod"
                >
                </experiment-methods-list>
            </v-card-text>
            <v-dialog v-model="experimentMethodFormDialogVisible" max-width="600px">
                <experiment-method-form
                    :experiment-method="selectedExperimentMethod"
                    @cancelForm="closeExperimentMethodForm"
                    @experimentMethodSaved="savedExperimentMethod"
                >
                </experiment-method-form>
            </v-dialog>
        </v-card>
    </v-container>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { withLoadingScreen } from "@/lib/loading.js";
import { useAuth } from "@/lib/ts/auth";
import ExperimentMethodsList from "@/components/ExperimentMethods/ExperimentMethodsList.vue";
import ExperimentMethodForm from "@/components/ExperimentMethods/ExperimentMethodForm.vue";
import { experimentMethodsAPI, SavedExperimentMethod } from "@/services/experimentMethods/experimentMethodsAPI";

const auth = useAuth();
const userCanManageExperimentMethods = computed(() => {
    return auth.isAuthorized("ExperimentMethods:Manage");
});

const experimentMethods = ref<SavedExperimentMethod[]>([]);
const experimentMethodFormDialogVisible = ref(false);
const selectedExperimentMethod = ref<SavedExperimentMethod | undefined>(undefined);

onMounted(async () => {
    await reloadExperimentMethods();
});
async function reloadExperimentMethods() {
    await withLoadingScreen(async () => {
        experimentMethods.value = await experimentMethodsAPI.fetchAllExperimentMethods();
    });
}

function showExperimentMethodForm() {
    selectedExperimentMethod.value = undefined;
    experimentMethodFormDialogVisible.value = true;
}

function closeExperimentMethodForm() {
    selectedExperimentMethod.value = undefined;
    experimentMethodFormDialogVisible.value = false;
}

function savedExperimentMethod() {
    closeExperimentMethodForm();
    reloadExperimentMethods();
}

function handleEditExperimentMethod(experimentMethod: SavedExperimentMethod) {
    selectedExperimentMethod.value = experimentMethod;
    experimentMethodFormDialogVisible.value = true;
}

</script>
